import React from "react";
import "./App.css";

export default function Footer() {
  return (
    <div className="Footer">
      Coded by Jen Xamin, open-source on{" "}
      <a
        href="https://github.com/JenLynX/dictionary-app"
        target="_blank"
        rel="noreferrer"
      >
        {" "}
        Github{" "}
      </a>
    </div>
  );
}
